import React from 'react';
import { useState, useEffect } from 'react';
import { getAllTemplates, getAllTemplatesByGroup, saveTemplate } from './service';
import View from './EmailTemplates.view';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import errorCb from 'Common/Utils/errorCb';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

const EmailTemplates = () => {
    document.title = `Contract Management - Email Templates`;    
	const initResult = { hasResult: false, result: null };
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [selectedGroupName, setSelectedGroupName] = useState('');
	const [templates, setTemplates] = useState([]);
	const [selectedTemplate, setSelectedTemplate] = useState('');
	const [fetched, setFetched] = useState(false);
	const [editedBody, editBody] = useState('');
	const [uploadResult, setUploadResult] = useState(initResult);
	const [isOpen, setOverlay] = useState(false);
	const [selectedTitle, setSelectedTitle] = useState('');
	const [showModal, setShowModal] = useState(false);
	const [redirectRequested, setRedirectRequested] = useState(false);
	const closeOverlay = () => setOverlay(false);
	const dispatch = useDispatch();

	const configs = {
		animate: true
	};

    const handleGroupChange = event => {
        // clear form
        setSelectedGroupId('');
        setSelectedGroupName('');
        setSelectedTemplate('');

        editBody('');
        setUploadResult({ hasResult: false, result: null });
        setSelectedTitle('');

        setSelectedGroupId(event.target.value);
        setSelectedGroupName(event.nativeEvent.target.innerText);
        let didCancel = false;
		async function getTemplates() {
			await getAllTemplatesByGroup(event.target.value, errorCb([], 'Error fetching templates.', dispatch)).then(res => {
				if (!didCancel) {
					setTemplates(res);
					setFetched(true);
				}
			});
		}
		getTemplates();

		return () => {
			didCancel = true;
		};
	};

    const handleChange = event => {
        setSelectedTemplate(event.target.value);

        let foundTemplate = findTemplate(event.target.value);
        let templateBody = convertFromHTML(foundTemplate.body);
        let blockArray = ContentState.createFromBlockArray(templateBody);
        let rteContent = EditorState.createWithContent(blockArray);

        editBody(rteContent);
        setUploadResult(initResult);
        setSelectedTitle(foundTemplate.name);
	};

	const findTemplate = templateId => {
		let foundValue = templates.find(element => {
			return element.nodeId === templateId;
		});
		if (typeof foundValue !== 'undefined' && foundValue !== null) {
			return foundValue;
		}
	};

	const redirectToHome = () => {
		setRedirectRequested(true);
	};

	const rteToHtml = () => {
		if (editedBody === '') return '';
		return draftToHtml(convertToRaw(editedBody.getCurrentContent()));
	};

	const isPreviewDisabled = selectedTemplate === '';
	const isSaveDisabled = selectedTemplate === '' || rteToHtml() === findTemplate(selectedTemplate).body;

	const submit = async () => {
		let foundValue = templates.find(element => {
			return element.nodeId === selectedTemplate;
		});
		let dto = {
			Id: foundValue.nodeId,
			Name: foundValue.name,
			LastUpdated: foundValue.lastUpdated,
			UpdatedBy: foundValue.updatedBy,
			Subject: foundValue.subject,
			Body: rteToHtml(),
			MergeFields: foundValue.mergeFields.toString()
		};
		const result = await saveTemplate(dto, errorCb([], 'Error posting template:' + dto.Id, dispatch));
		setFetched(false);
		setUploadResult({ hasResult: true, result });
	};

	const showHtml = () => {
		setShowModal(true);
	};

	const handleOk = () => {
		setShowModal(false);
	};

	const bodyChanged = value => {
		editBody(value);
		setUploadResult(initResult);
	};

	if (redirectRequested) {
		return <Redirect push to="/"></Redirect>;
	}

	return (
		<View
			handleGroupChange={handleGroupChange}
            selectedGroupId={selectedGroupId}
            selectedGroupName={selectedGroupName}
			handleChange={handleChange}
			templates={templates}
			submit={submit}
			bodyChanged={bodyChanged}
			selectedTemplate={selectedTemplate}
			editedBody={editedBody}
			uploadResult={uploadResult}
			configs={configs}
			isOpen={isOpen}
			closeOverlay={closeOverlay}
			setOverlay={setOverlay}
			findTemplate={findTemplate}
			selectedTitle={selectedTitle}
			rteToHtml={rteToHtml}
			isSaveDisabled={isSaveDisabled}
			isPreviewDisabled={isPreviewDisabled}
			handleOk={handleOk}
			showModal={showModal}
			showHtml={showHtml}
			redirectToHome={redirectToHome}
		/>
	);
};

export default EmailTemplates;
